<script setup lang="ts">
import { useOverlayStore } from "@/shop/store"
import { ref } from "vue"
import { useRouter } from "vue-router"
import { sleep } from "@/vf"
import { useShopAppConfig } from "@/shop/composables"

function close(): void {
    overlayStore.close()
}

function searchFor(str: string) {
    router.push({ name: "articles", query: { search: str } })
    overlayStore.close()
}

const { appConfig } = useShopAppConfig()
const overlayStore = useOverlayStore()
const router = useRouter()
const searchValue = ref("")
const searchInput = ref<HTMLInputElement | null>(null)

sleep(100).then(() => searchInput.value?.focus())
</script>

<template>
    <div class="search">
        <button class="overlay-close" @click="close()">
            <i class="fa fa-times"></i>
        </button>

        <div class="search-inner">
            <form @submit.prevent="searchFor(searchValue)">
                <div class="search-field">
                    <label for="search_input" class="sr-only">Suchbegriff eingeben</label>
                    <input
                        id="search_input"
                        ref="searchInput"
                        v-model="searchValue"
                        type="search"
                        placeholder="Suchbegriff eingeben..."
                    />
                    <i class="fa fa-search" @click="searchFor(searchValue)"></i>
                </div>
            </form>
            <template v-if="appConfig.searchTerms.length > 0">
                <section aria-label="Häufig gesucht" class="search-heading mt-5 mb-4">Häufige Suchbegriffe</section>

                <div class="search-buttons">
                    <button
                        v-for="searchTerm in appConfig.searchTerms"
                        :key="searchTerm"
                        class="btn btn-primary mb-2"
                        @click="searchFor(searchTerm)"
                    >
                        {{ searchTerm }}
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>
